import './App.css'
import Home from './pages/home/Home'
import Profile from './pages/Profile/Profile'
import Auth from './pages/Auth/Auth'
import CreateNote from './pages/CreateNote/CreateNote'
import ViewAllNote from './pages/CreateNote/ViewAllNote'
import Tool from './pages/Tool/Tool'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Element } from 'react-scroll'
import Landing from './pages/Landing/Landing'
import Logs from './pages/Logs/Logs'
import Reset from './pages/Auth/ResetPassword'
import SessionChecker from './SessionChecker'
import GeneralModal from './components/Main/GeneralModal/GeneralModal';
import VerifyEmail from './pages/VerifyEmail/VerifyEmail';
import DeepLink from './pages/DeepLink/DeepLink'

function App() {
  const user = useSelector((state) => state.authReducer.authData?.user);
  return (
    <div className="App">
      <SessionChecker />
      {user && <GeneralModal />}
      <Element id="anchor_top" name="anchor_top"></Element>

      <Routes>
        {/* Home and Landing Route */}
        <Route 
          path="/" 
          element={user ? <Navigate to="home" /> : <Navigate to="landing" />} 
        />
        <Route 
          path="/landing" 
          element={<Landing />} 
        />
        
        {/* Auth Routes for SignUp, Login, ForgotPassword */}
        <Route 
            path='/auth' 
            element={user ? <Navigate to="../home" /> : <Auth />}
          />
        <Route
            path="/auth/reset-password"
            element={<Reset/>}
          />
          <Route path="/auth/verify-email" element={<VerifyEmail />} />

        {/* Home Route */}
        <Route 
          path="/home" 
          element={user ? <Home /> : <Navigate to="/auth" />} 
        />
        
        {/* Notes Routes */}
        <Route 
          path="/createnote" 
          element={user && user.isAdmin ? <CreateNote /> : <Auth />} 
        />
        <Route 
          path="/viewnote" 
          element={user ? <ViewAllNote /> : <Auth />} 
        />

        {/* Profile Route */}
        <Route 
          path="/profile/:id" 
          element={user ? <Profile /> : <Navigate to="/landing" />} 
        />

        {/* Logs Route (Admin only) */}
        <Route 
          path="/logs" 
          element={user && user.isAdmin ? <Logs /> : <Navigate to="/home" />} 
        />

        {/* Tool Route */}
        <Route 
          path="/tool" 
          element={user ? <Tool /> : <Navigate to="/auth" />} 
        />
        <Route path="/link" element={<DeepLink />} />
      </Routes>

    </div>
  )
}

export default App
